import { DescriptionDropdownOption } from 'src/app/components/description-dropdown/description-dropdown.component';

// Shared by project create's task list and the task builder, which both let any task be given a specific
// team member whatever the project's Task Assignment setting is.

const NO_CLIENT_ACCESS_DESCRIPTION = "Doesn't have access to all clients this project is being created for.";

// The "nobody specific" option - what happens to the task instead, per the project's Task Assignment.
// "Specify Team Members" (2) has none: every task needs a member, so the dropdown's placeholder is used.
function NoMemberOption(project_assignment_settings: any): DescriptionDropdownOption | null {
  switch (Number(project_assignment_settings)) {
    case 3: return { value: '', label: 'Will Be Auto Assigned', icon: 'fa-solid fa-wand-magic-sparkles', description: 'A team member on this project will be assigned automatically based on their skills and availability once the project starts.' };
    case 2: return null;
    case 1: return { value: '', label: 'Team Members Can Claim', icon: 'fa-solid fa-hand', description: 'Left unassigned - any team member on this project can claim it once the project starts.' };
    default: return { value: '', label: 'Project Leader Assigns', icon: 'fa-solid fa-user-tie', description: 'Left for the project leader to assign.' };
  }
}

export const TASK_MEMBER_PLACEHOLDER = 'Select a team member';

// Options for the team member dropdown: the project's "nobody specific" choice, then every team member -
// the ones who can't access all of the project's clients are listed but disabled, saying why.
export function BuildTaskMemberOptions(project_assignment_settings: any, members: any[],
  can_assign: (member: any) => boolean): DescriptionDropdownOption[] {
  const options: DescriptionDropdownOption[] = [];
  const no_member = NoMemberOption(project_assignment_settings);
  if (no_member) options.push(no_member);
  for (const member of (members || [])) {
    const allowed = can_assign(member);
    options.push({
      value: member.guid,
      label: member.display_name,
      icon: 'fa-solid fa-user',
      description: allowed ? (member.email || '') : NO_CLIENT_ACCESS_DESCRIPTION,
      disabled: !allowed
    });
  }
  return options;
}

// The dropdown re-renders its menu whenever it's given a new options array, so the options are only rebuilt
// when something they depend on actually changes (not on every change detection).
export class TaskMemberOptionsCache {
  private settings: any;
  private members: any[] | null = null;
  private assignable: Set<string> | null | undefined = undefined;
  private options: DescriptionDropdownOption[] = [];

  Get(project_assignment_settings: any, members: any[], assignable: Set<string> | null): DescriptionDropdownOption[] {
    if (this.settings !== project_assignment_settings || this.members !== members || this.assignable !== assignable) {
      this.settings = project_assignment_settings;
      this.members = members;
      this.assignable = assignable;
      this.options = BuildTaskMemberOptions(project_assignment_settings, members,
        member => !assignable || assignable.has(member?.guid));
    }
    return this.options;
  }
}
